export default __webpack_public_path__ + "static/Smile-4b4b98061895f5c06df2dc0ea03885ac.png";